// import React, { useContext, useEffect, useState } from "react";
// import { AuthContext } from "../context/AuthContext";
// import { API_URL } from "../../Constants";
// import { useNavigate } from "react-router-dom";

// const ViewInvoice = () => {
//   const { user } = useContext(AuthContext);
//   const [invoices, setInvoices] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [invoiceToDelete, setInvoiceToDelete] = useState(null);

//   const navigate = useNavigate();

//   const companyId =
//     user?.accountType === "COMPANY" ? user?.id : user?.companyId;
//   const token = user?.token || localStorage.getItem("token");

//   const fetchInvoices = async () => {
//     try {
//       const response = await fetch(
//         `${API_URL}/api/invoices/company/${companyId}`,
//         {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       if (!response.ok) throw new Error("Failed to fetch invoices");

//       const data = await response.json();
//       setInvoices(data.invoices);
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (token && companyId) fetchInvoices();
//   }, [companyId, token]);

//   const getInvoicePdf = async (invoiceId, download = false) => {
//     try {
//       const response = await fetch(`${API_URL}/api/invoices/${invoiceId}/pdf`, {
//         method: "GET",
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       if (!response.ok) throw new Error("Failed to download invoice");

//       const blob = await response.blob();
//       const pdfUrl = URL.createObjectURL(blob);

//       const disposition = response.headers.get("Content-Disposition");
//       let filename = "invoice.pdf";

//       if (disposition && disposition.includes("filename=")) {
//         const match = disposition.match(
//           /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
//         );
//         if (match?.[1]) {
//           filename = match[1].replace(/['"]/g, "");
//         }
//       }

//       if (download) {
//         const link = document.createElement("a");
//         link.href = pdfUrl;
//         link.download = filename;
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//       } else {
//         window.open(pdfUrl, "_blank");
//       }
//     } catch (error) {
//       console.error("Error fetching invoice PDF:", error);
//     }
//   };

//   const handleEdit = (invoice) => {
//     navigate("/invoice", {
//       state: {
//         invoiceData: invoice,
//         isEditMode: true,
//       },
//     });
//   };

//   const handleDeleteClick = (invoiceId) => {
//     setInvoiceToDelete(invoiceId);
//     setShowDeleteModal(true);
//   };

//   const handleDeleteConfirm = async () => {
//     if (invoiceToDelete) {
//       try {
//         const response = await fetch(
//           `${API_URL}/api/invoices/${invoiceToDelete}`,
//           {
//             method: "DELETE",
//             headers: {
//               Authorization: `Bearer ${token}`,
//             },
//           }
//         );

//         if (!response.ok) throw new Error("Failed to delete invoice");

//         // Refresh the invoice list
//         fetchInvoices();
//       } catch (err) {
//         setError(err.message);
//       } finally {
//         setShowDeleteModal(false);
//         setInvoiceToDelete(null);
//       }
//     }
//   };

//   const handleDeleteCancel = () => {
//     setShowDeleteModal(false);
//     setInvoiceToDelete(null);
//   };

//   return (
//     <div className="p-2">
//       {/* Delete Confirmation Modal (unchanged) */}
//       {showDeleteModal && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 ">
//           <div className="bg-white p-4 sm:p-6 rounded-lg max-w-md w-full mx-4 dark:bg-gray-900 dark:text-white">
//             <h3 className="text-lg font-medium mb-4">Confirm Delete</h3>
//             <p className="mb-6">
//               Are you sure you want to delete this invoice?
//             </p>
//             <div className="flex justify-end space-x-3">
//               <button
//                 onClick={handleDeleteCancel}
//                 className="px-3 py-1 sm:px-4 sm:py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 text-sm sm:text-base"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleDeleteConfirm}
//                 className="px-3 py-1 sm:px-4 sm:py-2 bg-red-600 text-white rounded-md hover:bg-red-700 text-sm sm:text-base"
//               >
//                 Delete
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       <div className="bg-gray-100 rounded-lg shadow-sm overflow-x-auto dark:bg-gray-900 dark:text-white">
//         <div className="p-3 sm:p-4 border-b">
//           <h2 className="text-lg sm:text-xl font-semibold text-gray-700 dark:text-white">
//             Invoice Details
//           </h2>
//         </div>

//         {loading ? (
//           <div className="p-4 sm:p-6 text-center text-blue-500 font-medium">
//             Loading invoices...
//           </div>
//         ) : error ? (
//           <div className="p-4 sm:p-6 text-center text-red-500 font-medium">
//             {error}
//           </div>
//         ) : invoices.length === 0 ? (
//           <div className="p-4 sm:p-6 text-center text-gray-500">
//             No invoices found.
//           </div>
//         ) : (
//           <div className="overflow-x-auto">
//             <table className="min-w-full divide-y divide-gray-200">
//               <thead className="bg-gray-200 dark:bg-gray-800">
//                 <tr>
//                   <th className="px-2 py-2 sm:px-4 sm:py-3 text-left text-xs sm:text-sm font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
//                     S No.
//                   </th>
//                   <th className="px-2 py-2 sm:px-4 sm:py-3 text-left text-xs sm:text-sm font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
//                     Invoice #
//                   </th>
//                   <th className="px-2 py-2 sm:px-4 sm:py-3 text-left text-xs sm:text-sm font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider hidden sm:table-cell">
//                     Company
//                   </th>
//                   <th className="px-2 py-2 sm:px-4 sm:py-3 text-left text-xs sm:text-sm font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider hidden md:table-cell">
//                     Type
//                   </th>
//                   <th className="px-2 py-2 sm:px-4 sm:py-3 text-left text-xs sm:text-sm font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
//                     Amount
//                   </th>
//                   <th className="px-2 py-2 sm:px-4 sm:py-3 text-left text-xs sm:text-sm font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider hidden lg:table-cell">
//                     Date
//                   </th>
//                   <th className="px-2 py-2 sm:px-4 sm:py-3 text-left text-xs sm:text-sm font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
//                     Actions
//                   </th>
//                 </tr>
//               </thead>
//               <tbody className="bg-white divide-y divide-gray-200 dark:bg-gray-800 dark:divide-gray-700">
//                 {invoices.map((invoice, index) => {
//                   const totalAmount = invoice.item.reduce(
//                     (sum, item) => sum + (item.total || 0),
//                     0
//                   );

//                   return (
//                     <tr
//                       key={invoice.invoiceId}
//                       className="hover:bg-gray-50 dark:hover:bg-gray-700"
//                     >
//                       <td className="px-2 py-2 sm:px-4 sm:py-3 whitespace-nowrap text-sm text-gray-700 dark:text-gray-300">
//                         {index + 1}
//                       </td>
//                       <td className="px-2 py-2 sm:px-4 sm:py-3 whitespace-nowrap text-sm text-gray-700 dark:text-gray-300">
//                         {invoice.invoiceNumber || "N/A"}
//                       </td>
//                       <td className="px-2 py-2 sm:px-4 sm:py-3 whitespace-nowrap text-sm text-gray-700 dark:text-gray-300 hidden sm:table-cell">
//                         {invoice.companyName}
//                       </td>
//                       <td className="px-2 py-2 sm:px-4 sm:py-3 whitespace-nowrap text-sm text-gray-700 dark:text-gray-300 hidden md:table-cell">
//                         {invoice.invoiceType}
//                       </td>
//                       <td className="px-2 py-2 sm:px-4 sm:py-3 whitespace-nowrap text-sm text-gray-700 dark:text-gray-300">
//                         ₹{totalAmount.toFixed(2)}
//                       </td>
//                       <td className="px-2 py-2 sm:px-4 sm:py-3 whitespace-nowrap text-sm text-gray-700 dark:text-gray-300 hidden lg:table-cell">
//                         {new Date(invoice.createdAt).toLocaleDateString()}
//                       </td>
//                       <td className="px-2 py-2 sm:px-4 sm:py-3 whitespace-nowrap text-sm text-gray-700 dark:text-gray-300">
//                         <div className="flex space-x-1 sm:space-x-2">
//                           <button
//                             onClick={() => getInvoicePdf(invoice.invoiceId)}
//                             className="text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300"
//                             title="Preview"
//                           >
//                             <svg
//                               xmlns="http://www.w3.org/2000/svg"
//                               className="h-4 w-4 sm:h-5 sm:w-5"
//                               fill="none"
//                               viewBox="0 0 24 24"
//                               stroke="currentColor"
//                             >
//                               <path
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                                 strokeWidth={2}
//                                 d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
//                               />
//                               <path
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                                 strokeWidth={2}
//                                 d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
//                               />
//                             </svg>
//                           </button>
//                           <button
//                             onClick={() =>
//                               getInvoicePdf(invoice.invoiceId, true)
//                             }
//                             className="text-green-600 hover:text-green-800 dark:text-green-400 dark:hover:text-green-300"
//                             title="Download"
//                           >
//                             <svg
//                               xmlns="http://www.w3.org/2000/svg"
//                               className="h-4 w-4 sm:h-5 sm:w-5"
//                               fill="none"
//                               viewBox="0 0 24 24"
//                               stroke="currentColor"
//                             >
//                               <path
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                                 strokeWidth={2}
//                                 d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
//                               />
//                             </svg>
//                           </button>
//                           <button
//                             onClick={() => handleEdit(invoice)}
//                             className="text-yellow-600 hover:text-yellow-800 dark:text-yellow-400 dark:hover:text-yellow-300"
//                             title="Edit"
//                           >
//                             <svg
//                               xmlns="http://www.w3.org/2000/svg"
//                               className="h-4 w-4 sm:h-5 sm:w-5"
//                               fill="none"
//                               viewBox="0 0 24 24"
//                               stroke="currentColor"
//                             >
//                               <path
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                                 strokeWidth={2}
//                                 d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
//                               />
//                             </svg>
//                           </button>
//                           <button
//                             onClick={() => handleDeleteClick(invoice.invoiceId)}
//                             className="text-red-600 hover:text-red-800 dark:text-red-400 dark:hover:text-red-300"
//                             title="Delete"
//                           >
//                             <svg
//                               xmlns="http://www.w3.org/2000/svg"
//                               className="h-4 w-4 sm:h-5 sm:w-5"
//                               fill="none"
//                               viewBox="0 0 24 24"
//                               stroke="currentColor"
//                             >
//                               <path
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                                 strokeWidth={2}
//                                 d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
//                               />
//                             </svg>
//                           </button>
//                         </div>
//                       </td>
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </table>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default ViewInvoice;






import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/AuthContext";
import { API_URL } from "../../Constants";
import { useNavigate } from "react-router-dom";
import { FaTrash } from "react-icons/fa"; // Importing icon for delete modal styling

const ViewInvoice = () => {
  const { user } = useContext(AuthContext);
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [invoiceToDelete, setInvoiceToDelete] = useState(null);

  const navigate = useNavigate();

  const companyId =
    user?.accountType === "COMPANY" ? user?.id : user?.companyId;
  const token = user?.token || localStorage.getItem("token");

  const fetchInvoices = async () => {
    try {
      const response = await fetch(
        `${API_URL}/api/invoices/company/${companyId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) throw new Error("Failed to fetch invoices");

      const data = await response.json();
      setInvoices(data.invoices);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token && companyId) fetchInvoices();
  }, [companyId, token]);

  const getInvoicePdf = async (invoiceId, download = false) => {
    try {
      const response = await fetch(`${API_URL}/api/invoices/${invoiceId}/pdf`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) throw new Error("Failed to download invoice");

      const blob = await response.blob();
      const pdfUrl = URL.createObjectURL(blob);

      const disposition = response.headers.get("Content-Disposition");
      let filename = "invoice.pdf";

      if (disposition && disposition.includes("filename=")) {
        const match = disposition.match(
          /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
        );
        if (match?.[1]) {
          filename = match[1].replace(/['"]/g, "");
        }
      }

      if (download) {
        const link = document.createElement("a");
        link.href = pdfUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        window.open(pdfUrl, "_blank");
      }
    } catch (error) {
      console.error("Error fetching invoice PDF:", error);
    }
  };

  const handleEdit = (invoice) => {
    navigate("/invoice", {
      state: {
        invoiceData: invoice,
        isEditMode: true,
      },
    });
  };

  const handleDeleteClick = (invoiceId) => {
    setInvoiceToDelete(invoiceId);
    setShowDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    if (invoiceToDelete) {
      try {
        const response = await fetch(
          `${API_URL}/api/invoices/${invoiceToDelete}`,
          {
            method: "DELETE",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) throw new Error("Failed to delete invoice");

        // Refresh the invoice list
        fetchInvoices();
      } catch (err) {
        setError(err.message);
      } finally {
        setShowDeleteModal(false);
        setInvoiceToDelete(null);
      }
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setInvoiceToDelete(null);
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Sora:wght@600;700&family=Inter:wght@400;500;600&display=swap'); 
        .cfg-heading { font-family: 'Sora', sans-serif; } 
        .cfg-font { font-family: 'Inter', sans-serif; }
      `}</style>

      <div className="w-full min-h-screen bg-[#FAF8FF] dark:bg-gray-900 p-4 md:p-6 lg:p-8 cfg-font">
        <div className="max-w-7xl mx-auto space-y-6">
          
          {/* Header */}
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4 mb-2">
            <h1 className="text-2xl sm:text-3xl font-bold cfg-heading text-[#1F2937] dark:text-white flex items-center gap-2">
              🧾 Manage Invoices
            </h1>
          </div>

          {/* Delete Confirmation Modal */}
          {showDeleteModal && (
            <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-black/50 p-4">
              <div className="bg-white w-full max-w-sm rounded-xl shadow-2xl p-6 relative dark:bg-gray-800 border border-[#E5E7EB] dark:border-gray-700 flex flex-col items-center">
                <div className="w-12 h-12 rounded-full bg-[#FEF2F2] dark:bg-red-900/30 flex items-center justify-center mb-4">
                  <FaTrash className="text-[#EF4444] text-xl" />
                </div>
                <h3 className="text-xl font-bold cfg-heading text-[#1F2937] dark:text-white mb-2">
                  Delete Confirmation
                </h3>
                <p className="text-[#6B7280] dark:text-gray-400 text-center mb-6 text-sm">
                  Are you sure you want to delete this invoice? This action cannot be undone.
                </p>
                <div className="flex justify-center gap-3 w-full">
                  <button
                    onClick={handleDeleteCancel}
                    className="flex-1 px-4 py-2 bg-[#F3F4F6] text-[#374151] border border-[#E5E7EB] rounded-md hover:bg-[#E5E7EB] transition font-semibold text-sm dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600 dark:hover:bg-gray-600"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleDeleteConfirm}
                    className="flex-1 px-4 py-2 bg-[#EF4444] text-white rounded-md hover:bg-[#B91C1C] shadow-md transition font-semibold text-sm"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Invoice Table Container */}
          <div className="bg-white rounded-xl shadow-sm border border-[#E5E7EB] dark:bg-gray-800 dark:border-gray-700 overflow-hidden">
            <div className="p-5 border-b border-[#E5E7EB] dark:border-gray-700">
              <h2 className="text-lg font-bold cfg-heading text-[#1F2937] dark:text-white">
                Invoice Directory
              </h2>
            </div>

            {loading ? (
              <div className="p-8 text-center text-[#673AB7] dark:text-[#E9D5FF] font-medium text-sm flex items-center justify-center gap-2">
                <svg className="animate-spin h-5 w-5 text-[#673AB7]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Loading records...
              </div>
            ) : error ? (
              <div className="p-8 text-center text-[#EF4444] bg-[#FEF2F2] dark:bg-red-900/10 font-medium text-sm">
                Error: {error}
              </div>
            ) : invoices.length === 0 ? (
              <div className="p-10 text-center text-[#6B7280] dark:text-gray-400 bg-gray-50 dark:bg-gray-800/50 text-sm">
                No invoices found in your directory.
              </div>
            ) : (
              <div className="overflow-x-auto scrollbar-thin scrollbar-thumb-[#E5E7EB] dark:scrollbar-thumb-gray-600">
                <table className="min-w-full divide-y divide-[#E5E7EB] dark:divide-gray-700">
                  <thead className="bg-[#FAF8FF] dark:bg-gray-700/50">
                    <tr>
                      <th className="px-4 py-4 text-left text-xs font-bold text-[#4B5563] dark:text-gray-300 uppercase tracking-wider">S No.</th>
                      <th className="px-4 py-4 text-left text-xs font-bold text-[#4B5563] dark:text-gray-300 uppercase tracking-wider">Invoice #</th>
                      <th className="px-4 py-4 text-left text-xs font-bold text-[#4B5563] dark:text-gray-300 uppercase tracking-wider hidden sm:table-cell">Company</th>
                      <th className="px-4 py-4 text-left text-xs font-bold text-[#4B5563] dark:text-gray-300 uppercase tracking-wider hidden md:table-cell">Type</th>
                      <th className="px-4 py-4 text-left text-xs font-bold text-[#4B5563] dark:text-gray-300 uppercase tracking-wider">Amount</th>
                      <th className="px-4 py-4 text-left text-xs font-bold text-[#4B5563] dark:text-gray-300 uppercase tracking-wider hidden lg:table-cell">Date</th>
                      <th className="px-4 py-4 text-left text-xs font-bold text-[#4B5563] dark:text-gray-300 uppercase tracking-wider">Actions</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-[#E5E7EB] dark:bg-gray-800 dark:divide-gray-700">
                    {invoices.map((invoice, index) => {
                      const totalAmount = invoice.item.reduce(
                        (sum, item) => sum + (item.total || 0),
                        0
                      );

                      return (
                        <tr
                          key={invoice.invoiceId}
                          className="hover:bg-[#F3E8FF]/30 dark:hover:bg-gray-700/50 transition"
                        >
                          <td className="px-4 py-4 whitespace-nowrap text-sm font-medium text-[#6B7280] dark:text-gray-400">
                            {index + 1}
                          </td>
                          <td className="px-4 py-4 whitespace-nowrap text-sm font-bold text-[#1F2937] dark:text-white">
                            {invoice.invoiceNumber || "N/A"}
                          </td>
                          <td className="px-4 py-4 whitespace-nowrap text-sm font-medium text-[#4B5563] dark:text-gray-300 hidden sm:table-cell">
                            {invoice.companyName}
                          </td>
                          <td className="px-4 py-4 whitespace-nowrap hidden md:table-cell">
                            <span className="inline-block px-2.5 py-1 text-xs font-semibold rounded border bg-[#F3E8FF] text-[#673AB7] border-[#E9D5FF] dark:bg-purple-900/30 dark:text-purple-300">
                              {invoice.invoiceType || "Invoice"}
                            </span>
                          </td>
                          <td className="px-4 py-4 whitespace-nowrap text-sm font-bold text-[#10B981] dark:text-[#34D399]">
                            ₹{totalAmount.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                          </td>
                          <td className="px-4 py-4 whitespace-nowrap text-sm font-medium text-[#6B7280] dark:text-gray-400 hidden lg:table-cell">
                            {new Date(invoice.createdAt).toLocaleDateString()}
                          </td>
                          <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
                            <div className="flex space-x-1 sm:space-x-3">
                              <button
                                onClick={() => getInvoicePdf(invoice.invoiceId)}
                                className="text-[#8B5CF6] hover:text-[#673AB7] dark:hover:text-[#E9D5FF] transition p-1.5 bg-gray-50 hover:bg-[#F3E8FF] dark:bg-gray-700 dark:hover:bg-gray-600 rounded-md shadow-sm"
                                title="Preview"
                              >
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 sm:h-4 sm:w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                </svg>
                              </button>
                              <button
                                onClick={() => getInvoicePdf(invoice.invoiceId, true)}
                                className="text-[#10B981] hover:text-[#059669] transition p-1.5 bg-gray-50 hover:bg-[#D1FAE5] dark:bg-gray-700 dark:hover:bg-gray-600 rounded-md shadow-sm"
                                title="Download"
                              >
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 sm:h-4 sm:w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                                </svg>
                              </button>
                              <button
                                onClick={() => handleEdit(invoice)}
                                className="text-yellow-500 hover:text-yellow-600 transition p-1.5 bg-gray-50 hover:bg-yellow-50 dark:bg-gray-700 dark:hover:bg-gray-600 rounded-md shadow-sm"
                                title="Edit"
                              >
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 sm:h-4 sm:w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                </svg>
                              </button>
                              <button
                                onClick={() => handleDeleteClick(invoice.invoiceId)}
                                className="text-[#EF4444] hover:text-[#B91C1C] transition p-1.5 bg-gray-50 hover:bg-[#FEF2F2] dark:bg-gray-700 dark:hover:bg-gray-600 rounded-md shadow-sm"
                                title="Delete"
                              >
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 sm:h-4 sm:w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                </svg>
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewInvoice;